import React, { useEffect, useState} from 'react'
import './review.css'
import C2wRatingCard from '../../../../common/C2wHome/Reviews/core2webRatingCard'
import C2wStudentRatingCard from '../../../../common/C2wHome/Reviews/core2webStudentRatingCard'
import { useLocation } from 'react-router'

function C2wReviews() {

  const path = useLocation()
  const [activeIndex, setActiveIndex] = useState(0)
  const activeIndexes = [0, 1, 2, 3, 4]; // Only apply active to these indexes
useEffect(() => {
  let currentIndex = 0;

  const interval = setInterval(() => {
    setActiveIndex(activeIndexes[currentIndex]);

    // Increment index, reset if it goes beyond array length
    currentIndex = (currentIndex + 1) % activeIndexes.length;
  }, 2000);
  return () => clearInterval(interval);
}, []);


    /**
   * @state windowWidth - Tracks the current width of the browser window.
   * @hook useEffect - Window Resize Listener
   * @author Vishal Lohbande
   * Description:
   * - Initializes `windowWidth` state with the current width of the browser window.
   * - Adds an event listener to update the state whenever the window is resized.
   *
   * Behavior:
   * - `handleResize` updates the `windowWidth` state using `window.innerWidth`.
   * - The resize listener is attached once on component mount.
   * - On unmount, the event listener is properly cleaned up to prevent memory leaks.
   *
   * Use Case:
   * - Responsive UI adjustments (e.g., conditional rendering based on screen width).
   * - Dynamic layout shifts or breakpoints detection in React components.
   *
   * Notes:
   * - This setup ensures that UI can respond in real-time to screen size changes.
   */
      const [windowWidth, setWindowWidth] = useState(window.innerWidth);
      useEffect(() => {
          const handleResize = () => {
              setWindowWidth(window.innerWidth);
          };
  
          window.addEventListener('resize', handleResize);
          return () => window.removeEventListener('resize', handleResize);
      }, []);



      const reviewsArray = path.pathname === '/' ?  [
        { star: 5, 
          name: 'Mansi Ganjewar', 
          desc: `Teaching is too good, even a non-IT person can understand easily. 
                 Everyday topic-related tasks help us to understand the topic 
                 more easily and gives us an opportunity to explore more.` 
        },
        { star: 5, 
          name: 'Prajyot Dhoke', 
          desc: `Awesome experience in classroom and practical based learning helpfull teacher and 
                 mentors. If you feeling studying programming language is boreing just come here..
                 your mind will change in one week.` 
        },
        { star: 5, 
          name: 'Varun Deshmukh', 
          desc: `Best for devlopers and students focused on programming field. one of the best programming 
                  classes due to their team coordination and mainly due to Shashi sir's way of teaching.` 
        },
         { star: 5, 
          name: 'Yash Parate', 
          desc: `Useful and effective platform for better learning experience!! Providing excellent facilities 
                 and features!! Absolutely a great platform for career guidance!!.` 
        },
        { star: 5, 
          name: 'Keshav Jaiwal', 
          desc: "The teaching method is unique and absolutely great. I've never learned like this before.                   If Sir is teaching something, it will be on the next level, explaining concepts deeply and thoroughly."
        },

        

      ] : [

        { star: 5, 
          name: 'Vedant Galinde', 
          desc: `A fantastic learning app! It's incredibly user-friendly, with a wide range of engaging lessons and activities. 
                 My knowledge and skills have improved significantly since I started using it. Highly recommended!` 
        },

        { star: 5, 
          name: 'Ayush Deshmukh', 
          desc: `It offers a revolutionary approach to learning coding by incorporating project-based tasks and interactive platforms. 
                 It enhances practical skills through hands-on experience and instant feedback.` 
        },

        { star: 5, 
          name: 'Sanket Bagade', 
          desc: `Great culture for student to grow , provide all round support to the student to grow in life, great supportive staff 
                 and provide great opportunities to work on technical skill and soft skills. Special thanks to shashi sir.` 
        },

        { star: 5, 
          name: 'Kushal Chahajgune', 
          desc: `It is very nice app.Easy to handle.All material is too good for Job preparations .Each and every topic taught in deep 
                 due to concepts got clear.` 
        },

        { star: 5, 
          name: 'Saurabh Saroj', 
          desc: `This learning app has transformed the way I absorb knowledge. It's like having a virtual tutor that makes programming 
                 learning not just effective, but also incredibly enjoyable!" love this app ❤️` 
        },
      ]

  return (
    windowWidth > 620 ? (
    <div className='C2wReviews_ctn_home'>
        <img className='C2wReviewsBg_img' src='/assets/images/reviews/reviewsBg.png' alt='reviewsBg' />
        <div className='C2wReviews_C2wRatingHolder'>
          <C2wRatingCard />
        </div>
        <div className=' C2wStudentRatingCard_holder C2wStudentRatingCard_holder1'>
          <C2wStudentRatingCard obj={reviewsArray[0]} />
        </div>
        <div className='C2wStudentRatingCard_holder C2wStudentRatingCard_holder2'>
          <C2wStudentRatingCard obj={reviewsArray[1]} />
          <C2wStudentRatingCard obj={reviewsArray[2]} />
        </div>
        <div className='C2wStudentRatingCard_holder C2wStudentRatingCard_holder3'>
          <C2wStudentRatingCard obj={reviewsArray[3]} />
          <C2wStudentRatingCard obj={reviewsArray[4]}/>
        </div>
    </div>
    ) : (
         <div className='C2wReviews_ctn_home'>
            <C2wRatingCard />
            <div className='C2wReview_studentRatingHolder'>
                { reviewsArray?.map((obj, index) => (
                  <C2wStudentRatingCard   
                    obj={obj} 
                    isActive={index === activeIndex}
                    />
                ))}
            
            </div>
            <img className='reviewsMobileBg' src='/assets/images/reviews/reviewsMobileBg.png' alt='reviewsMobileBg' />
         </div>
         
    )
  )
}

export default C2wReviews
